import { PdfColorMode } from '../types/fingering';

export const PDF_COLOR_MODE_KEY = 'omakase-unshi:pdf-color-mode';

const VALID_MODES: ReadonlyArray<PdfColorMode> = ['mono', 'color'];
// issue #32 v2: 未設定ユーザーには弦別色 (カラー) を既定にする。
// issue #39: 'string' → 'color' へリネーム。 既存 localStorage 'mono' ユーザーはその設定を維持する。
const DEFAULT_MODE: PdfColorMode = 'color';

/** 旧値 'string' (issue #39 リネーム前の値) を読んだときに新値 'color' に書き直すための alias。
 *  起動時 lazy 1 回 migration。 2026-07-01 以降に grep で消せる (issue #39 後続ガード)。 */
const LEGACY_STRING_VALUE = 'string';

function isValidMode(value: string): value is PdfColorMode {
  return (VALID_MODES as ReadonlyArray<string>).includes(value);
}

export function getPdfColorMode(): PdfColorMode {
  if (typeof window === 'undefined') return DEFAULT_MODE;
  try {
    const raw = window.localStorage.getItem(PDF_COLOR_MODE_KEY);
    // issue #39 migration: 旧 'string' を読んだら新 'color' に書き直す (lazy 1 回 migration)。
    if (raw === LEGACY_STRING_VALUE) {
      setPdfColorMode('color');
      return 'color';
    }
    if (raw && isValidMode(raw)) return raw;
    return DEFAULT_MODE;
  } catch {
    return DEFAULT_MODE;
  }
}

export function setPdfColorMode(mode: PdfColorMode): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(PDF_COLOR_MODE_KEY, mode);
  } catch {
    // SSR / iframe / disabled storage — silently ignore
  }
}
